/**
 * Bundled OS logos for the purchase page (no hotlinking).
 * Linux marks: simple-icons (CC0, see LICENSE-simple-icons.md); windows / generic drawn here.
 */
import ubuntu from './ubuntu.svg';
import debian from './debian.svg';
import centos from './centos.svg';
import rocky from './rocky.svg';
import almalinux from './almalinux.svg';
import alpine from './alpine.svg';
import fedora from './fedora.svg';
import opensuse from './opensuse.svg';
import arch from './arch.svg';
import freebsd from './freebsd.svg';
import rhel from './rhel.svg';
import linux from './linux.svg';
import windows from './windows.svg';
import generic from './generic.svg';

/** family key → { name, logo }; order = display order. */
export const OS_FAMILIES = [
    { key: 'ubuntu', name: 'Ubuntu', logo: ubuntu, match: /ubuntu/i },
    { key: 'debian', name: 'Debian', logo: debian, match: /debian/i },
    { key: 'rocky', name: 'Rocky Linux', logo: rocky, match: /rocky/i },
    { key: 'almalinux', name: 'AlmaLinux', logo: almalinux, match: /alma/i },
    { key: 'centos', name: 'CentOS', logo: centos, match: /centos/i },
    { key: 'rhel', name: 'Red Hat', logo: rhel, match: /red ?hat|rhel/i },
    { key: 'fedora', name: 'Fedora', logo: fedora, match: /fedora/i },
    { key: 'opensuse', name: 'openSUSE', logo: opensuse, match: /suse/i },
    { key: 'alpine', name: 'Alpine', logo: alpine, match: /alpine/i },
    { key: 'arch', name: 'Arch Linux', logo: arch, match: /\barch/i },
    { key: 'freebsd', name: 'FreeBSD', logo: freebsd, match: /freebsd/i },
    { key: 'windows-server', name: 'Windows Server', logo: windows, match: /windows server/i },
    { key: 'windows', name: 'Windows', logo: windows, match: /windows/i },
    { key: 'linux', name: 'Linux', logo: linux, match: /linux/i },
];

export const GENERIC_OS_LOGO = generic;

/** Family of an image ({name, type}): by name first, then by type; unknown → its type, generic logo. */
export const osFamily = (img) => {
    const hay = `${img?.name || ''} ${img?.type || ''}`;
    const byName = OS_FAMILIES.find((f) => f.match.test(img?.name || ''));
    const f = byName || OS_FAMILIES.find((x) => x.match.test(hay));
    if (f) return f;
    const type = String(img?.type || 'other');
    return { key: type, name: type.charAt(0).toUpperCase() + type.slice(1), logo: generic };
};
